import { render, staticRenderFns } from "./custom_org_sla_view.vue?vue&type=template&id=35873acf"
import script from "./custom_org_sla_view.vue?vue&type=script&lang=js"
export * from "./custom_org_sla_view.vue?vue&type=script&lang=js"
import style0 from "./custom_org_sla_view.vue?vue&type=style&index=0&id=35873acf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports